import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyMapmenuDividerCss = ":host{display:block;margin:8px 0;height:1px;background:rgba(1, 30, 57, 0.08)}";

const MapyMapmenuDivider$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapmenuDivider extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
  }
  render() {
    return h(Host, null);
  }
  static get style() { return mapyMapmenuDividerCss; }
}, [1, "mapy-mapmenu-divider"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-mapmenu-divider"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-mapmenu-divider":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapmenuDivider$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapmenuDivider = MapyMapmenuDivider$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapmenuDivider, defineCustomElement };

//# sourceMappingURL=mapy-mapmenu-divider.js.map